import { Stack } from "@mui/material";
import { FC } from "react";
import logo from "@/assets/images/logo.svg";

type TLoginLogoProps = {};

export const LoginLogo: FC<TLoginLogoProps> = () => {
  return (
    <Stack gap={1} alignItems="center">
      <Stack>
        <img width={351} src={logo} alt="logo" />
      </Stack>
    </Stack>
  );
};
